module.exports = __webpack_public_path__ + "img/pal-orange.25e64f1e.svg";